<template>
  <div
    class="flex flex-col justify-center items-center content-center w-full h-128"
  >
    <div class="w-full mb-2">
      <gd-button 
        variant="outline"
        size="auto"
        @click="$emit('clickedBackButton')"
      > 
        {{ $t('frontend_back') }}
      </gd-button>
    </div>

    <div class="w-1/2 flex flex-col justify-center items-center content-center">
      <p class="font-bold text-lg text-dark antialiased text-center mx-24">
        {{ $t('frontend_subdomain_editor_lets_choose_free') }}
      </p>

      <p class="text-grey-600 antialiased mt-4">
        {{ $t('frontend_subdomain_editor_will_be_your_primary_subdomain') }}
      </p>

      <div class="flex items-center flex-row text-grey-600 mt-8">
        <div class="flex flex-wrap content-end mr-2">https://</div>
        <div class="flex flex-col mr-2">
          <text-input v-model="newSubDomain"></text-input>
        </div>
        <div class="flex flex-wrap content-end">.{{ groovepagesDomain }}</div>
      </div>
    </div>
    <div class="mt-8 flex flex-col w-1/2 px-8">
      <gd-button
        :loading="savingSub"
        @click="saveSubDomain"
        variant="primary"
        size="expand"
      >
        {{ $t('frontend_save') }}
      </gd-button>
      <p class="mt-2 text-sm text-center text-danger">{{ errorMsg }}</p>
    </div>
    <upgrade-modal ref="upgradeModal" />
  </div>
</template>

<script>
import api from '@groovepages/gd-lib/api';
import Auth from '@groovepages/gd-lib/auth';
import Notify from '../notify';
import { actions } from '@groovepages/gd-lib/userPermissions';
import UpgradeModal from '@groovepages/gd-ui-kit/components/UpgradeModal';
import AccountDomainRecordEditor from './AccountDomainRecordEditor';
import GdButton from './Button';
import ConfirmModal from './ConfirmModal';
import GdModal from './Modal';
import TextInput from './TextInput';

export default {
  name: 'SubdomainEditor',
  components: {
    GdModal,
    ConfirmModal,
    AccountDomainRecordEditor,
    GdButton,
    TextInput,
    UpgradeModal,
  },
  computed: {
    subDomain() {
      return (
        this.$store.getters.user.metadata &&
        this.$store.getters.user.metadata.subdomain
      );
    },
    groovepagesDomain() {
      return window.gdEnv['VUE_APP_GROOVEPAGES_URL']?.match(/\/\/(.+)$/)[1] || 'groovepages.com'
    }
  },
  data() {
    return {
      setupGrooveDomain: false,
      errorMsg: '',
      newSubDomain: '',
      savingSub: false,
    };
  },
  created() {
    this.newSubDomain = this.subDomain;
  },
  methods: {
    saveSubDomain() {
      const userFeature = Auth.fetchFeatureValue(actions.SUB_DOMAINS);
      if(userFeature == 0) {
        this.$refs.upgradeModal.open();
      } else {
        setTimeout(() => {
          if (this.validURL(`https://www${this.newSubDomain}.${this.groovepagesDomain}`)) {
            this.changeSubdomain();
            this.errorMsg = '';
          } else {
            this.errorMsg = this.$t('frontend_gduikit_account_domain_invalid_url');
          }
        }, 500);
      }
    },
    async changeSubdomain() {
      if (!this.newSubDomain) {
        return;
      }

      if (this.newSubDomain === this.subDomain) {
        this.errorMsg = this.$t('frontend_gduikit_account_domain_same_subdomain');
        return;
      }

      this.savingSub = true;
      let response = { available: true };
      if (this.newSubDomain !== this.subDomain) {
        this.savingSub = true;
        response = await api.get(
          `${window.gdEnv.VUE_APP_API_URL}/groovepages/sites/check-subdomain/${this.newSubDomain}`
        );
      }
      if (!response.available) {
        this.errorMsg = this.$t('frontend_domain_dropdown_subdomain_unavailable');
        this.savingSub = false;
        return;
      }
      api
        .get(
          `${window.gdEnv.VUE_APP_API_URL}/groovepages/sites/move-subdomain/${this.newSubDomain}`
        )
        .then(() => {
          this.$store.commit('updateUserMetadata', {
            subdomain: this.newSubDomain,
          });
          this.errorMsg = '';
          this.savingSub = false;
          this.setUpDomain = false;
          Notify.success(this.$t('frontend_subdomain_editor_successfully_updated_subdomain'));
        });
    },

    showError(e) {
      console.error(e);
      if (e) {
        if (e && e.response && e.response.data.errors) {
          return Notify.fail(
            e.response.data.errors[0].message,
            e.response.data.errors.map(({ message }) => message).join('. ')
          );
        }
        return Notify.fail(e.message);
      }
    },
    validURL(str) {
      const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ); // fragment locator
      return !!pattern.test(str);
    },
  },
};
</script>
